export default "__VITE_ASSET__6629949c__"